import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { User, ErrCode } from '../../shared/models';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../core/logger.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'sync-email-change-verify',
    templateUrl: './email-change-verify.component.html',
})
export class EmailChangeVerifyComponent implements OnInit, OnDestroy {
    public confirmcode: string;
    public user: User;
    public errcode: ErrCode;
    public spinner: boolean;
    public authenticated: boolean;

    public verified: boolean;

    private sub: Subscription;

    constructor(
        private api: ApiService,
        private log: LoggerService,
        private store: Store<fromRoot.State>,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.spinner = false;
        this.errcode = undefined;
        this.sub = this.store
            .select(fromRoot.getAuthState)
            .subscribe((data) => {
                this.authenticated = data.authenticated;
                if (!data.authenticated) {
                    this.user = new User();
                    return;
                }
                if (data.user) {
                    this.user = data.user;
                }
            });
        this.confirmcode = this.route.snapshot.queryParams['d'];

        if (this.confirmcode) {
            this.verify();
        } else {
            this.errcode = new ErrCode(8104);
        }
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    public async verify() {
        this.spinner = true;
        this.verified = false;
        try {
            await this.api.send('userverifychangedemail', {
                verify_code: this.confirmcode,
            });
            this.spinner = false;
            this.verified = true;
        } catch (ex) {
            this.spinner = false;
            this.errcode = ErrCode.fromException(ex);
            this.log.e('Error verifying email change', this.errcode);
        }
    }
}
